{"mieteGebucht":"Diese Miete gehört zur Buchhaltung. Ändere sie unter Buchhaltung über „Miete ändern“."}